import { Steps } from 'antd';
import styled from 'styled-components';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { animated } from '@react-spring/web';
import { media } from 'ui';

// https://css-tricks.com/forums/topic/hide-text-but-not-the-before-pseudo-class/
export const StyledSteps = styled(Steps)`
  margin: 0 180px;
  @media (max-width: 770px) {
    margin: 10px;
  }
  padding: 10px 0;
  @media (max-width: 1296px) {
    .ant-steps-item-title {
      text-indent: -9999px;
    }
  };
  width: auto;
  .ant-steps-item-title {
    text-transform: uppercase;
    font-weight: 600;
  }
  .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-icon > .ant-steps-icon {
    color: rgba(0, 0, 0, 0.35) !important;
  }
  .ant-steps-item-description {
    text-decoration: underline;
  }
  .ant-steps-item-finish > .ant-steps-item-container >
  .ant-steps-item-content > .ant-steps-item-title,
  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-icon > .ant-steps-icon {
    color: ${p => p.theme.colors.publishSteps.finish} !important;
  }

  .ant-steps-item-warning > .ant-steps-item-container >
  .ant-steps-item-content > .ant-steps-item-title,
  .ant-steps-item-warning > .ant-steps-item-container > .ant-steps-item-icon > .ant-steps-icon {
    color: ${p => p.theme.colors.publishSteps.warning} !important;
  }

  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-icon > .ant-steps-icon {
    top: -2px;
  }
  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-icon {
    border-color: ${p => p.theme.colors.publishSteps.finish} !important;
  }
  .ant-steps-item-warning > .ant-steps-item-container > .ant-steps-item-icon {
    border-color: ${p => p.theme.colors.publishSteps.warning} !important;
    .ant-steps-icon {
      font-size: 24px !important;
    }
  }
  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-icon,
  .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-icon {
    width: 27px !important;
    height: 27px !important;
    background-color: transparent !important;
  }
  .ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-icon {
    border: 1px solid ${p => p.theme.colors.publishSteps.error} !important;
    background-color: transparent !important;
  }
  .ant-steps-item-error > .ant-steps-item-container >
  .ant-steps-item-content > .ant-steps-item-title {
    color: ${p => p.theme.colors.publishSteps.error} !important;
  }
  .ant-steps-item-error > .ant-steps-item-container > .ant-steps-item-title {
    width: 27px !important;
    height: 27px !important;
  }

  .line-finish > .ant-steps-item-container > .ant-steps-item-content >
  .ant-steps-item-title::after {
    background-color: #27AE60 !important;
  }

  .line-error > .ant-steps-item-container > .ant-steps-item-content >
  .ant-steps-item-title::after {
    background-color: #CC0000 !important;
  }

  .line-warning > .ant-steps-item-container > .ant-steps-item-content >
  .ant-steps-item-title::after {
    background-color: #ff9600 !important;
  }

  .ant-steps-item-custom > .ant-steps-item-container > .ant-steps-item-icon {
    width: 27px !important;
    height: 27px !important;
  }
  .ant-steps-item-custom > .ant-steps-item-container >
  .ant-steps-item-icon > .ant-steps-icon {
    vertical-align: 0 !important
    left: unset;
    font-size: 17px;
    top: -2px;
  }
  .ant-steps-item-error > .ant-steps-item-container >
  .ant-steps-item-content > .ant-steps-item-title,
  .ant-steps-item-error > .ant-steps-item-container >
  .ant-steps-item-icon > .ant-steps-icon {
    color: ${p => p.theme.colors.publishSteps.error} !important;
  }
  .ant-steps-item-process > .ant-steps-item-container >
  .ant-steps-item-content > .ant-steps-item-title {
    color: ${p => p.theme.colors.theme} !important;
  }
  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon > ant-steps-icon {
    color: ${p => p.theme.colors.theme} !important;
  }
  .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-icon > .ant-steps-icon {
    top: -3px;
    left: 0.5px;
  }
  @media (max-width: 480px) {
    display: flex !important;
    .ant-steps-item-container > .ant-steps-item-content {
      display: inline-block !important;
    }
    .ant-steps-item-container > .ant-steps-item-tail {
      display: none !important;
    }
  }
`;

export const StyledUpIcon = styled(UpOutlined)`
  margin-left: 3px;
`;

export const StyledDownIcon = styled(DownOutlined)`
  margin-left: 3px;
`;

export const StyledSpan = styled.span`
  color: ${p => p.isWarning ?
    p.theme.colors.publishSteps.warning :
    p.theme.colors.publishSteps.error} !important;
  cursor: pointer;
  font-size: 12px;
  text-decoration: underline;
`;

export const AbortSpan = styled.span`
  color: ${p => p.theme.colors.publishSteps.process} !important;
  cursor: pointer;
`;

export const ProcessInfo = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
`;

export const AbortText = styled(AbortSpan)`
  margin-left: 15px;
  font-weight: normal !important;
  text-transform: none !important;
  text-decoration: underline;
`;

export const StyledDiv = styled(animated.div)`
  background-color: rgb(245, 248, 250) !important;
  margin: 0 -20px;
  border: ${p => p.bordered &&
    // eslint-disable-next-line
    `2px solid ${p.hasErrors ? p.theme.colors.publishSteps.error : p.hasWarnings ? p.theme.colors.publishSteps.warning : p.theme.colors.theme}`} !important;
  position: -webkit-sticky;
  position: sticky;
  top: 161px;
  ${media.tablet`
    top: 55px !important;
    transform: unset !important;
  `};
  z-index: 110;
`;

export const Text = styled.p`
  ${p => p.marginTop && `margin-top: ${p.marginTop}px;`}
`;
